AddPageSwapTrigger(function() {
    $('#drilldown-menu').on('click', 'a', function() {
        $(document).scrollTop(0);
    })

    $(document).swipeleft(function(event) {
        if($("body").hasClass('toggled2')) {
            $('#menu-toggle2').click();
        }

        if($("body").hasClass('toggled')) {
            $('#menu-toggle').click();
        }
    });

});

AddPageSwapTrigger(function () {
    var fncMenuToggle = function () {
        $("body").removeClass('toggled');
        $("body").removeClass('toggled2');
        $(".menu-toggle2").unbind("click.toggle");
        $(".menu-toggle2").bind("click.toggle", function (e) {
            e.preventDefault();
            // $("#wrapper").toggleClass("toggled");
            if ($("#wrapper").hasClass("toggled-off")) {
                $("#wrapper").removeClass("toggled-off").addClass("toggled2");
                // $("#tawkchat-container").removeClass("toggled-off").addClass("toggled2");
                $("body").removeClass("toggled-off").addClass("toggled2");
            }
            else if ($("#wrapper").hasClass("toggled2")) {
                $("#wrapper").removeClass("toggled2").addClass("toggled-off2");
                // $("#tawkchat-container").removeClass("toggled2").addClass("toggled-off2");
                $("body").removeClass("toggled2").addClass("toggled-off2");
            } else {
                $("#wrapper").addClass("toggled2").removeClass("toggled-off2");
                // $("#tawkchat-container").addClass("toggled2").removeClass("toggled-off2");
                $("body").addClass("toggled2").removeClass("toggled-off2");
            }

            $('html, body').animate({scrollTop: 0}, 'fast');
        });
    }
    fncMenuToggle();
});

AddPageSwapTrigger(function () {
    $(".menu-toggle").unbind('click');
    $(".menu-toggle").click(function (e) {
        e.preventDefault();

        $('nav .panel-heading a').each(function () {
            $(this).click(fncUpdateFooterPosition);

            if (!($(this).is('.collapsed'))) {
                $(this).click();
            }
        });

        if ($("#wrapper").hasClass("toggled-off2")) {
            $("#wrapper").removeClass("toggled-off2").addClass("toggled");
            $("body").removeClass("toggled-off2").addClass("toggled");
        }
        else if ($("#wrapper").hasClass("toggled")) {
            $("#wrapper").removeClass("toggled").addClass("toggled-off");
            $("body").removeClass("toggled").addClass("toggled-off");
        }
        else {
            $("#wrapper").addClass("toggled").removeClass("toggled-off");
            $("body").addClass("toggled").removeClass("toggled-off");
        }

        $('html, body').animate({scrollTop: 0}, 'fast');
    });
});